/**
 * HE.Clipboard
 */

(function Clipboard($, HE)
{
	"use strict";

	var clipboard = function copyTextToClipboard(data) {
		if (navigator.clipboard) {
			modernCopy(data);
		}
		else {
			oldCopy(data);
		}
	};

	// new hotness; https://www.w3.org/TR/clipboard-apis/#async-clipboard-api
	function modernCopy(data)
	{
		navigator.clipboard.writeText(data.text)
			.then(function copied() {
				console.log('Successfully copied:', data.text);
				if (data.success) {
					HE.StatusMessage('success', data.success);
				}
			}, function error(err) {
				console.error('Clipboard error:', err);
				HE.StatusMessage('error', 'Error copying to clipboard - ' + err);
			})
			.catch(function catchError(err) {
				console.error('Clipboard catch error:', err);
				HE.StatusMessage('error', 'Failed to copy - ' + err);
			});
	}

	// deprecated
	// deprecated
	function oldCopy(data)
	{
		console.log('Using oldCopy fallback method');
		console.log('Text to copy:', data.text);

		let textarea = document.createElement('textarea');
		textarea.value = data.text;

		// Make it invisible but accessible
		textarea.style.position = 'absolute';
		textarea.style.left = '-9999px';
		textarea.style.top = '0';

		document.body.appendChild(textarea);

		// Focus and select
		textarea.focus();
		textarea.select();

		// For mobile devices
		if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
			let range = document.createRange();
			range.selectNodeContents(textarea);

			let selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(range);
			textarea.setSelectionRange(0, 999999);
		}

		console.log('Selected text:', window.getSelection().toString());
		console.log('Textarea value:', textarea.value);

		let successful = false;

		try {
			successful = document.execCommand('copy');
			console.log('execCommand result:', successful);

			if (successful) {
				console.log('Successfully copied using oldCopy:', data.text);
				if (data.success) {
					HE.StatusMessage('success', data.success);
				}
			} else {
				console.error('execCommand returned false');
				HE.StatusMessage('error', 'Failed to copy to clipboard');
			}
		} catch (err) {
			console.error('oldCopy error:', err);
			HE.StatusMessage('error', 'Error copying to clipboard - ' + err);
		}

		document.body.removeChild(textarea);
	}

	$(document).on('click', '.copy-to-clipboard', function startClipboardCopy(e) {
		var data = $(this).data();
		e.preventDefault();

		if (data.secretText) {
			data.text = atob(data.secretText);
		}

		if (!data.text) {
			throw new Error('missing text to copy');
		}

		clipboard({
			text   : data.text,
			success: data.success || null,
		});
	});

	HE.Clipboard = clipboard;
}(jQuery, window.HE || {}));
